import { render, staticRenderFns } from "./WorkspaceTutorial.vue?vue&type=template&id=10578dee&scoped=true"
import script from "./WorkspaceTutorial.vue?vue&type=script&lang=js"
export * from "./WorkspaceTutorial.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceTutorial.vue?vue&type=style&index=0&id=10578dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10578dee",
  null
  
)

export default component.exports